<template>
  <b-modal
    ref="print-document"
    hide-footer
    @hide="reset"
  >
    <div class="d-block text-center">
      <b-container v-if="!documentPrinted" fluid>
        <h5>Le document {{ code }} a bien été créé !</h5>
        <div class="document-created-icon">
          <i class="fa fa-check-circle"></i>
        </div>
        <b-button
          variant="primary"
          class="mt-3"
          @click="printDocument()"
        >Imprimer l'étiquette</b-button>
      </b-container>
      <b-container v-if="documentPrinted" fluid>
        <h5>Impression de l'étiquette faite !</h5>
        <div class="document-created-icon">
          <i class="fa fa-check-circle"></i>
        </div>
        <b-button
          variant="outline-secondary"
          class="mt-3"
          @click="reset"
        >Créer un autre document</b-button>
        <b-button
          variant="primary"
          class="mt-3"
          @click="goTo('/tracking_order/' + code)"
        >Voir le suivi</b-button>
      </b-container>
    </div>
  </b-modal>
</template>
<script>
import printHeureServer from '../../api/printHeureServer.vue'
import ZebraPrinter from '../../core/services/ZebraPrinter.js'

export default {
  name: 'PrintDocumentModal',
  props: ['code', 'form'],
  data () {
    return {
      documentPrinted: false,
      zebraPrinter : new ZebraPrinter(),
    }
  },
  methods: {
    reset () {
      this.documentPrinted = false
      this.$refs['print-document'].hide()
      this.$emit('reset-form')
    },
    hideModal () {
      this.$refs['print-document'].hide()
      this.$emit('reset-form')
    },
    showModal () {
      this.$refs['print-document'].show()
    },
    printDocument () {
      if (localStorage.getItem('printer_type') === 'zebra' ||
        this.isUserThales()) 
      {
        var cmds =  `^XA~TA000~JSN^LT0^MNW^MTT^PON"
        ^PMN^LH0,0^JMA^PR6,6~SD15^JUS
        ^LRN^CI27^PA0,1,1,0^XZ^XA^MMT^PW609^LL405
        ^LS0
        ^BY3,3,195^FT26,287^BCN,,Y,N^FH\^FD${this.code}^FS
        ^FT204,353^A0N,32,33^FH\^CI28^FD${this.form.description}^FS^CI27
        ^FT250,67^A0N,36,35^FH\^CI28^FD${this.form.loop}^FS^CI27^PQ1,0,1,Y^XZ`
        this.zebraPrinter.send(cmds).then((result) => {
          this.$emit('reset-form')
          this.documentPrinted = true
        }).catch((error) => {
          this.$toasted.error(`Impossible d'imprimer ...<br>Êtes-vous connecté à l'imprimante zebra ?`)
          console.log(error)
        })
      } else {
        const data = [{ CODE: this.code }]
        printHeureServer.printDocument(data).then(() => {
          this.$emit('reset-form')
          this.documentPrinted = true
        }).catch((error) => {
          this.$toasted.error(`Erreur d'impression ! ${error}`)
        })
      }
    },
  }
}
</script>
<style>
.document-created-icon {
  font-size: 10rem;
  margin: 0 auto;
  color: var(--success);
}
</style>



// WEBPACK FOOTER //
// src/components/document/PrintDocumentModal.vue